import { SelectOptionContract } from '@/shared/ui';
import z from 'zod';

export enum FloorPlanStatus {
  VACANT = 'VACANT',
  OCCUPIED = 'OCCUPIED',
}

export enum FloorPlanHistoryStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const FacilityFloorPlanFiltersFormValuesSchema = z.object({
  statuses: z.array(SelectOptionContract).nullable(),
  /**
   * The Floor filter was removed (card #157, Anna's comment 326) because its
   * options duplicated per facility. The store still carries `floors` so the
   * control can be restored as a UI-only change, but it is no longer part of
   * the form — leaving it here made the form permanently invalid, which
   * disabled the Apply Filters button.
   */
  /** Portfolio Mode only; absent when the table is scoped to one facility. */
  facilities: z.array(SelectOptionContract).nullable(),
});
